import { apiUserNeeds } from '@spo/services/api';
import { SpoCreateUserNeedBodyUserNeeds } from '@spo/types';
import { useMutation } from '@tanstack/react-query';

export const useCreateUserNeed = (
  sportId: string,
  natureId: string,
  onSuccess: () => void,
  onError: () => void,
) => {
  return useMutation({
    mutationKey: ['useCreateUserNeed', sportId, natureId],
    mutationFn: async (userNeeds: SpoCreateUserNeedBodyUserNeeds) =>
      apiUserNeeds.createUserNeed({
        userNeeds,
        language: 'EN',
      }),
    onSuccess,
    onError,
  });
};
